import { Stack, Typography, ListItem, Avatar, Box } from '@mui/material';
import { INotificationsDocument, markNotificationAsVisited } from 'API';
import { format } from 'date-fns';
import { useIsDesktop } from 'Hooks';
import { File, NotificationBlueCircle } from 'Images';
import { downloadFile } from 'Utils';
interface IDocument {
  document: INotificationsDocument;
}

export const Document = ({ document }: IDocument) => {
  const downloadDocument = () => {
    downloadFile(
      document.documentData.documentBase64,
      document.documentData.documentNameWithExtension,
      document.documentData.documentName
    );
  };

  const isDesktop = useIsDesktop();

  return (
    <ListItem
      sx={{
        paddingX: '0',
        cursor: 'pointer',
      }}
    >
      <Box
        sx={{
          width: '100%',
          boxShadow: '0px 4px 28px rgba(45, 112, 217, 0.15)',
          borderRadius: '16px',
          p: '24px',
          background: '#FFF',
        }}
        onClick={async () => {
          downloadDocument();
          document.isVisited = true;
          await markNotificationAsVisited({
            itemId: document.itemId,
            typeId: document.notifciationTypeId,
          });
        }}
      >
        {!document.isVisited && (
          <Avatar
            src={NotificationBlueCircle}
            alt={''}
            sx={{
              position: 'absolute',
              top: '-6px',
              left: '-13px',
            }}
          />
        )}
        <Stack>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: '14px',
              lineHeight: '18px',
              color: '#60727E',
            }}
          >
            {format(new Date(document.date), 'dd/MM/yyyy')}
          </Typography>
          {document.title && (
            <Typography
              variant='h3'
              sx={{
                fontWeight: 700,
                lineHeight: '16px',
                mt: 1,
              }}
            >
              {document.title}
            </Typography>
          )}
          {document.description && (
            <Typography lineHeight={'22px'}>{document.description}</Typography>
          )}
          <Stack gap='4px' mt={2} flexDirection='row' alignItems='center'>
            <Avatar sx={{ height: '24px', width: '24px' }} src={File} alt='' />
            <Typography
              component={'a'}
              sx={{
                lineHeight: '22px',
                color: '#1752AF',
                fontSize: isDesktop ? '18px' : '16px',
              }}
            >
              {document.documentData.documentName}
            </Typography>
          </Stack>
        </Stack>
      </Box>
    </ListItem>
  );
};
